
import { Component, Vue, Prop } from "vue-property-decorator";
import ObjectTable from "./ObjectTable.vue";

import { IBot, botType } from "../../../server/src/ai/interface/IBot"

import BotParamsVue from "./BotParamsVue.vue";
import { BotStore } from "./interface/BotStore";

import Bus from "@/lib/Bus";
const bus: Bus = new Bus().getBus();
import { DragManager, typeMoveBot, typeSelectBot, typeMoveParam, typeMoveObj } from "./DragManager";


@Component({ components: { ObjectTable, BotParamsVue } })
export default class BotVue extends Vue {
  key = 0;
  can_see_code = false;
  btype=botType
  dm=DragManager.getInstance()  

  @Prop(Object) bot_prop: IBot | undefined;
  bot: IBot|undefined
  store: BotStore | undefined;


  async mounted() {
    console.log("bot mounted")
    this.can_see_code = bus.get_user()._id == "MANPROC1";
    
    if (this.bot_prop) this.store = await BotStore.getInstance(this.bot_prop.parent_id);

    if (this.bot_prop && this.bot_prop.id) {
      this.bot=this.bot_prop
      this.bot.id=this.bot_prop.id
      this.show(this.bot);  
    }
    
  }

  beforeDestroy() {
  }


  async show(obj?: any) {
    console.log("bot show:key++")
    this.key++;
  }

  async expandBot(bot:IBot, event:MouseEvent) {
    event.stopPropagation()
    event.preventDefault()
    if (!this.bot) return;
    if (!this.bot?.expanded) this.bot.expanded = true;
    else this.bot.expanded = false;
    //console.log("this.expandBot")
     if ((event.button === 2)) {
    this.dm.set(bot, typeSelectBot)
    this.dm.show_tooltip(bot.prompt, event.clientX-10, event.clientY+10 )
     }
    //this.$emit("hilight_bot", bot)
    //await this.save_bot()

    //this.key++;
  }

  async save_bot() {
    if (!this.store) return;

    if (!this.bot) return;
    console.log("save_bot", this.bot);
    await this.store.saveBot(this.bot);
  }

  

  
  async run_bot(bot:IBot, event:MouseEvent) {
    event.stopPropagation()
    event.preventDefault()
    if ((event.button === 2)) {
        this.dm.set(bot, typeSelectBot)
        this.dm.show_tooltip(bot.prompt, event.clientX-10, event.clientY+10 )
        return;
      } else {
        this.$emit("run_bot",bot)
      }
  }

  async handleMouseDown1(bot: IBot,parent_id: string, event:MouseEvent, left_pan?:number) {
    console.log("bot: mouse down")
    event.stopPropagation()
    event.preventDefault()
    this.$emit("hilight_bot", bot)
    this.$emit("bot_mouse_down",{bot: bot,parent_id: bot.parent_id, event:event, left_pan:1})
  }

  async handleMouseUp1(bot:IBot, event:MouseEvent) {
    console.log("bot: mouse up")
    event.stopPropagation()
    event.preventDefault()
    this.$emit("bot_mouse_up",{bot: bot,event:event})
  }

  async handleDelBot(bot:IBot, event:MouseEvent) {
    console.log("bot: del")
    event.stopPropagation()
    event.preventDefault()
    this.$emit("bot_del",{bot: bot,event:event})
  }

  async mouse_ignore(event:MouseEvent) {
    event.stopPropagation()
    event.preventDefault()
  }

  copyToNotepad(value:string, event:MouseEvent) {
    event.stopPropagation()
    event.preventDefault()

    if (!this.bot) return;
    const valueToCopy = JSON.stringify(value);

    // Create a temporary textarea element to facilitate copying to clipboard
    const textarea = document.createElement('textarea');
    textarea.value = valueToCopy;
    document.body.appendChild(textarea);

    // Select the value within the textarea
    textarea.select();
    textarea.setSelectionRange(0, 99999); // For mobile devices

    // Copy the selected text to clipboard
    document.execCommand('copy');

    // Remove the temporary textarea
    document.body.removeChild(textarea);

    alert('Skopiowano do notatnika.');
  }

}
